module.exports = __webpack_public_path__ + "lr.svg?858d04ce4b0659062db7562dcbd1b5fa";